<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div class="consequence-container">
            <div class="info bv bc fz_30">
                <div class="ico-win bg-contain"></div>
                <div class="fz_34 fwb">提现申请成功，预计1-3个工作日内到账</div>
                <div class="fz_30 c_999 message tc">请等待管理员处理</div>
            </div>
            <div class="points fz_30 bh bbetween">
                <span class="c_999">提现车主币(个)</span>
                {{parseInt(infoData.withdrawPointAmount)}}
            </div>
            <div class="money fz_30 bh bbetween">
                <span class="c_999">预计到账金额(元)</span>
                {{infoData.money}}
            </div>
            <div class="fz_30 bh bbetween">
                <span class="c_999">提现方式</span>
                {{infoData.bankName}}({{infoData.bankCardNumber}})
            </div>
        </div>
        <div class="bh bc footBar">
            <van-button
                @click="replaceGo('UserMoneyHome',{isVerification:true})"
                class="btn btn-goodbuy"
            >
                <span class="fz_30 btn-span">完成</span>
            </van-button>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import util from "@/utils/index";
export default {
    mixins: [routeCache, user],
    name: "MoneyConsequence",
    data() {
        return {
            infoData: ""
        };
    },
    created() {
        const data = this.getCache();
        data.bankCardNumber = util.sliceLast(data.bankCardNumber);
        this.infoData = data;
    }
};
</script>
<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
    .consequence-container {
        background-color: #fff;
        padding: 89px 30px 40px 30px;
    }
    .ico-win {
        width: 116px;
        height: 116px;
        margin-bottom: 38px;
    }
    .message {
        width: 100%;
        padding: 29px 0 91px 0;
        border-bottom: 1px solid #dcdcdc;
    }
    .points {
        padding-top: 39px;
    }
    .money {
        padding: 38px 0 40px 0;
    }
    .footBar {
        margin-top: 91px;
        .btn-goodbuy {
            width: 510px;
            height: 76px;
        }
    }
}
</style>
